export const footerLinks = {
  PRIVACY: {
    url:
      process.env.REACT_APP_UI_CUSTOM_PRIVACY_URL ||
      'https://www.sttok.com/privacidad/',
    text: 'Privacy',
  },
  LEGAL: {
    url:
      process.env.REACT_APP_UI_CUSTOM_LEGAL_URL ||
      'https://www.sttok.com/aviso-legal/',
    text: 'LegalWarning',
  },
  COOKIES: {
    url:
      process.env.REACT_APP_UI_CUSTOM_COOKIES_URL ||
      'https://www.sttok.com/privacidad/',
    text: 'Cookies',
  },
};
